import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {GetTriggerCategoryResponseDto} from '../models/GetTriggerCategoryResponseDto';
import {SessionStorageService} from './session-storage.service';
import {HttpResponse} from '@angular/common/http';

@Injectable()
export class TriggerCategoriesService {

    triggerCategoriesCacheKey = 'triggerCategories';

    constructor(private httpService: HttpService, private sessionStorageService: SessionStorageService) {}

    getTriggerCategoryById(id: number): Observable<HttpResponse<GetTriggerCategoryResponseDto>> {
        const categoryId = id.toString();
        const url = environment.ENDPOINTS.GET_TRIGGER_CATEGORY_BY_ID.replace('{:id}', categoryId);
        return this.httpService.getJson<GetTriggerCategoryResponseDto>(url);
    }

    getAll(): Observable<Array<GetTriggerCategoryResponseDto>> {
        const triggerCategories = this.sessionStorageService.get(this.triggerCategoriesCacheKey);
        if (triggerCategories != null) {
            return Observable.of(triggerCategories);
        } else {
            return Observable.create(observer => {
                const url = environment.ENDPOINTS.GET_ALL_TRIGGER_CATEGORIES;
                this.httpService.getJson<Array<GetTriggerCategoryResponseDto>>(url).subscribe(response => {
                    this.sessionStorageService.set(this.triggerCategoriesCacheKey, response.body);
                    observer.next(response.body);
                    observer.complete();
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/trigger-categories.service.ts